import { RsuiteToggle } from "@components/adapters/rsuite/Toggle";
import type { ToggleProps } from "@components/contracts/Toggle.types";

export const Toggle: React.FC<ToggleProps> = (props) => (
  <RsuiteToggle {...props} />
);

export type { ToggleProps };
